module.exports = __webpack_public_path__ + "img/east-meets-dress_thumbnail.91b8d6f1.jpg";